//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Tooling.js";
import "../Features/Features.FeatureBuilder.js";
import "../no/SelectBodyList.js";
import "../no/SelectBody.js";
import "../no/SelectObject.js";
import "../no/SelectObjectList.js";
let d=[[[0,"SewTolerance",1,0],[1,"SourceBody",0,"SelectBodyList",0],[0,"SpringbackMethod",1,0],[1,"TargetBody",0,"SelectBody",0]],[[[],"DefineSpringback",{},0,0],[[],"SetProperty",{},0,0]],[]];
SPLM.Tooling.DieEngStampingOutputBuilder = class extends SPLM.Features.FeatureBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.Tooling.DieEngStampingOutputBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

SPLM.Tooling.DieEngStampingOutputBuilder.DisplayProductType = Object.freeze({
    "OriginalProduct" : "OriginalProduct", "NewProduct" : "NewProduct", "Both" : "Both"});

SPLM.Tooling.DieEngStampingOutputBuilder.SpringbackMethodType = Object.freeze({
    "None" : "None", "UniformMembraneExpansion" : "UniformMembraneExpansion", "OvercrownbyFunction" : "OvercrownbyFunction", "OvercrownbySurface" : "OvercrownbySurface"});

export default SPLM;